import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_crate_ticket_modal",
  ref: "ticketModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_8 = { class: "mb-13 text-center" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "alert alert-dismissible bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row p-5 mb-10" }
const _hoisted_11 = { class: "svg-icon svg-icon-2hx svg-icon-primary" }
const _hoisted_12 = { class: "d-flex flex-column pe-0 pe-sm-10" }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "fw-normal" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "0219169033", -1)
const _hoisted_16 = { class: "row g-9" }
const _hoisted_17 = { class: "col-md-12 fv-row" }
const _hoisted_18 = { class: "d-flex flex-column fv-row" }
const _hoisted_19 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_20 = {
  key: 0,
  class: "fv-plugins-message-container invalid-feedback"
}
const _hoisted_21 = { class: "col-md-6 fv-row" }
const _hoisted_22 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_23 = { value: "high" }
const _hoisted_24 = { value: "medium" }
const _hoisted_25 = { value: "low" }
const _hoisted_26 = {
  key: 0,
  class: "fv-plugins-message-container invalid-feedback"
}
const _hoisted_27 = { class: "col-md-6 fv-row" }
const _hoisted_28 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 0,
  class: "fv-plugins-message-container invalid-feedback"
}
const _hoisted_31 = { class: "col-12 fv-row mb-10" }
const _hoisted_32 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = {
  key: 0,
  class: "fv-plugins-message-container invalid-feedback"
}
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = {
  type: "reset",
  id: "kt_modal_new_target_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_37 = ["data-kt-indicator"]
const _hoisted_38 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_39 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_40 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_form, {
            id: "kt_modal_new_target_form",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.targetData,
            rules: _ctx.rules,
            ref: "formRef",
            class: "form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.translate("Submit a support ticket")), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen048.svg" })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.translate("pay attention")), 1),
                  _createElementVNode("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.translate(
                      "To solve technical problems only response is done by ticketing For advice and non-technical questions you can contact the number"
                    )) + " ", 1),
                    _hoisted_15,
                    _createTextVNode(_toDisplayString(_ctx.translate("call")) + ".", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate("Ticket title")), 1)
                    ]),
                    _createVNode(_component_el_form_item, {
                      class: "mb-0",
                      prop: "targetTitle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.targetData.title,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.title) = $event)),
                          placeholder: _ctx.translate('Enter the title of the ticket')
                        }, null, 8, ["modelValue", "placeholder"]),
                        (_ctx.errorsBag.title)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.errorsBag.title[0]), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.translate("Priority")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.priority) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.translate("Top")), 1),
                    _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.translate("medium")), 1),
                    _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.translate("Unnecessary")), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.targetData.priority]
                  ]),
                  (_ctx.errorsBag.priority)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.errorsBag.priority[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate("The relevant section")), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.department_id) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (department, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: department.id
                      }, _toDisplayString(department.name), 9, _hoisted_29))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.targetData.department_id]
                  ]),
                  (_ctx.errorsBag.department_id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.errorsBag.department_id[0]), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate("Message")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    type: "textarea",
                    class: "form-control form-control-lg mw-260px",
                    name: "message",
                    rows: "2",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.message) = $event)),
                    placeholder: _ctx.translate('Enter your message')
                  }, null, 8, _hoisted_33), [
                    [_vModelText, _ctx.targetData.message]
                  ]),
                  (_ctx.errorsBag.message)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.errorsBag.message[0]), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", _hoisted_36, _toDisplayString(_ctx.translate("cancel")), 1),
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                        _createTextVNode(_toDisplayString(_ctx.translate("send")) + " ", 1),
                        _createElementVNode("span", _hoisted_39, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                        _hoisted_41
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_37)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ], 512))
}